import React, { useEffect, useState } from "react";
import { db } from "../../../firebaseConfig"; 
import { collection, getDocs, updateDoc, doc, query, where } from "firebase/firestore";

// --- CONFIGURATION ---
// CHANGE THIS PASSWORD to whatever you want your "Master Key" to be.
const MASTER_PASSWORD = "1098"; 

export default function AdminAccessControl() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState("");
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);

  // Pages we can block. The 'key' must match the keys in AdminDashboard.js
  const BLOCKABLE_PAGES = [
    { key: "employee__rate", label: "Pay Rate" },
    { key: "employee__payroll", label: "Payroll" },
    { key: "employee__logging", label: "Log Hours" },
    { key: "access_control", label: "Access Control Page" }, 
  ];

  // 1. Fetch Admins when unlocked
  useEffect(() => {
    if (isUnlocked) fetchAdmins();
  }, [isUnlocked]);

  const fetchAdmins = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "users"), where("role", "in", ["admin"])); // add "tutor" when you need.
      const snap = await getDocs(q);
      
      // Filter clientside to be safe or ensure your DB query is specific
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setAdmins(list);
    } catch (e) {
      alert("Error loading admins: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUnlock = (e) => {
    e.preventDefault();
    if (password === MASTER_PASSWORD) {
      setIsUnlocked(true);
    } else {
      alert("Incorrect Master Password");
      setPassword("");
    }
  };

  const togglePermission = async (adminId, pageKey, currentBlockedList) => {
    const blocked = Array.isArray(currentBlockedList) ? currentBlockedList : [];
    let newBlocked;

    if (blocked.includes(pageKey)) {
      // Unblock it (remove from list)
      newBlocked = blocked.filter(k => k !== pageKey);
    } else {
      // Block it (add to list)
      newBlocked = [...blocked, pageKey];
    }

    // Update Local State immediately for UI responsiveness
    setAdmins(prev => prev.map(a => a.id === adminId ? { ...a, blockedPages: newBlocked } : a));

    // Save to Firebase
    try {
      await updateDoc(doc(db, "users", adminId), {
        blockedPages: newBlocked
      });
    } catch (err) {
      console.error("Failed to save permission:", err);
      alert("Failed to save. Check console.");
    }
  };

  if (!isUnlocked) {
    return (
      <div style={{ padding: 40, display: "flex", justifyContent: "center" }}>
        <form onSubmit={handleUnlock} style={{ padding: 30, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
          <h3 style={{ marginTop: 0, color: "#0f172a" }}>Master Admin Access</h3>
          <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>Enter the master password to manage admin permissions.</p>
          <input 
            type="password" 
            placeholder="Enter Password..." 
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 6, border: "1px solid #cbd5e1", marginBottom: 12, boxSizing: "border-box" }}
          />
          <button type="submit" style={{ width: "100%", padding: 10, background: "#0f172a", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}>
            Unlock
          </button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: 20, height: "100%", overflowY: "auto" }}>
      <h2 style={{ color: "#0f172a" }}>Admin Access Control</h2>
      <p style={{ color: "#64748b", fontSize: 14 }}>
        Check the boxes below to <b>BLOCK</b> access to that page for the specific user.
      </p>

      {loading && <div>Loading users...</div>}

      <div style={{ display: "grid", gap: 16, marginTop: 20 }}>
        {admins.map(user => (
          <div key={user.id} style={{ background: "#fff", padding: 16, borderRadius: 12, border: "1px solid #e2e8f0", display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ borderBottom: "1px solid #f1f5f9", paddingBottom: 8 }}>
              <div style={{ fontWeight: 800, fontSize: 16, color: "#0f172a" }}>{user.name || "Unnamed User"}</div>
              <div style={{ fontSize: 12, color: "#64748b" }}>{user.email} ({user.role || "No Role"})</div>
            </div>
            
            <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
              {BLOCKABLE_PAGES.map(page => {
                const isBlocked = user.blockedPages?.includes(page.key);
                return (
                  <label key={page.key} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, fontWeight: 600, color: isBlocked ? "#dc2626" : "#334155", cursor: "pointer", border: "1px solid #e2e8f0", padding: "6px 10px", borderRadius: 8, background: isBlocked ? "#fef2f2" : "#fff" }}>
                    <input 
                      type="checkbox" 
                      checked={isBlocked} 
                      onChange={() => togglePermission(user.id, page.key, user.blockedPages)}
                    />
                    {isBlocked ? `Blocked: ${page.label}` : page.label}
                  </label>
                )
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}